import React from 'react';
import { useSelector } from 'react-redux';
import { TableCell } from 'semantic-ui-react';

import { AppState } from 'services/types';
import { SprayEventForSubmission } from 'services/sprayEventsForSubmission/types';
import { selectSprayEventOperatorNames } from './selectors';

export interface OwnProps {
    sprayEventId: SprayEventForSubmission['id'];
}

type Props = OwnProps;

export default function RenderSubmissionSprayEventsTableRowApplicatorCell(
    props: Props
): React.ReactElement {
    const sprayOperatorNames = useSelector((state: AppState) =>
        selectSprayEventOperatorNames(state, props)
    );

    return (
        <TableCell textAlign="left" className="events-table-cell-padding">
            {sprayOperatorNames}
        </TableCell>
    );
}
